var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinCommunityLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 83,
    viewBox: "0 0 53 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0417 26.9619V38.1795C29.4798 38.1842 33.734 39.9478 36.8718 43.0855C40.0095 46.2232 41.7746 50.4774 41.7778 54.9155C41.7731 59.3519 40.0079 63.6062 36.8702 66.7439C33.7325 69.8816 29.4782 71.6452 25.0417 71.6499V82.869C40.457 82.869 53 70.3276 53 54.9108C53 39.5033 40.4586 26.9619 25.0417 26.9619Z",
    fill: "#AB854A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0417 60.4655C23.5718 60.4639 22.1631 59.8781 21.1235 58.8385C20.0839 57.7989 19.4997 56.3902 19.4981 54.9203C19.4981 51.8674 21.9873 49.3783 25.0402 49.3783V38.1592C20.5959 38.1639 16.3337 39.9322 13.1913 43.0746C10.0505 46.217 8.28216 50.4792 8.27588 54.9235C8.28059 59.3693 10.0489 63.6299 13.1913 66.7739C16.3337 69.9163 20.5959 71.6846 25.0417 71.6893V60.4623V60.4655Z",
    fill: "#AB854A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinCommunityLogo);
export default __webpack_public_path__ + "static/media/join_community_logo.38140182fee664b31cb56c17329cc08c.svg";
export { ForwardRef as ReactComponent };